/*
 * @Description:
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */
//入口
import { invoice } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

import Company from '../components/company';
import Add from '../components/add';

//初始化
export let example = new TableRenderClass({ fields, search });

/*主页面入口*/
export const main = [
  {
    name: '发票管理',
    childMenu: [
      example.createPart({
        name: '发票管理',
        search: ['xsf', 'status'],
        moreBtnArr: [
          // {
          //   name: '申请开票',
          //   type: 'warning',
          //   fn(app, table) {
          //     table.$xrkDialog({
          //       title: '申请开票',
          //       width: '90vw',
          //       showCancel: false,
          //       showConfirm: false,
          //       $slots: {
          //         default: table.$createElement(Add, {
          //           props: {
          //             isEdit: true
          //           },
          //           on: {
          //             confirm: () => {
          //               table.saveSuccess();
          //               table.$xrkDialog.remove();
          //             }
          //           }
          //         })
          //       }
          //     });
          //   }
          // },
          {
            name: '开票信息维护',
            type: 'warning',
            fn(app, table) {
              table.$xrkDialog({
                title: '开票信息维护',
                width: '90vw',
                showCancel: false,
                showConfirm: false,
                $slots: {
                  default: table.$createElement(Company, {
                    props: {},
                    on: {
                      confirm: () => {
                        table.saveSuccess();
                        table.$xrkDialog.remove();
                      }
                    }
                  })
                }
              });
            }
          }
        ],
        list: invoice.list,
        requestNow: true,
        fields: [
          'index',
          'xsf',
          'xsfNo',
          'money',
          'invoiceCatalogue',
          'invoiceType',
          // 'applyDt',
          'invoiceStatus',
          'billingDt',
          'operation'
        ]
      })
    ]
  }
];
